<template>
  <div class="tg-nodata">
    <el-image :style="styleObj" :src="noDataIcon"></el-image>
    <p v-if="breadcrumb" style="padding-top:20px;">{{ breadcrumb }}</p>
    <p style="padding-top:20px;">{{ label }}</p>
  </div>
</template>

<script>
import icon from "@/config/icon";
export default {
  props: {
    isNeedSearch: Boolean,
    isNeedSearchWithBetId: Boolean,
    isFixing: Boolean,
    breadcrumb: String,
  },
  computed: {
    iconName() {
      return process.env.VUE_APP_VERSION == "v2.2" ? "data" : "no-info";
    },
    noDataIcon() {
      if (this.isNeedSearch) {
        return icon["member-search"];
      } else if(this.isNeedSearchWithBetId){
        return icon["member-search"];
      } else {
        return icon[this.iconName];
      }
    },
    label() {
      if (this.isNeedSearch) {
        return this.$t("component.table.plzEnterMemberAccountToSearch");
      } else if(this.isNeedSearchWithBetId){
        return this.$t("component.table.plzEnterBetIdOrMemberAccountToSearch");
      } else if(this.isFixing) {
        return this.$t("component.table.fixing");
      } else {
        return this.$t("component.table.nodata");
      }
    },
    styleObj() {
      return {
        width: this.iconName == "data" ? "300px" : "140px",
        height: this.iconName == "data" ? "150px" : "160px",
        // "margin-top": this.iconName == "data" ? "50px" : "50px",
      };
    },
  },
};
</script>
